import { ReactNode } from 'react';

interface AssessmentLayoutProps {
  /** Header content — rendered sticky at top. Each screen provides its own. */
  header?: ReactNode;
  /** Footer content — rendered sticky at bottom. Optional. */
  footer?: ReactNode;
  /** Background color. Defaults to white. */
  backgroundColor?: string;
  /** Children rendered in the scrollable content area */
  children: ReactNode;
}

export default function AssessmentLayout({
  header,
  footer,
  backgroundColor = '#FFFFFF',
  children,
}: AssessmentLayoutProps) {
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor }}
    >
      {/* Sticky header */}
      {header && (
        <div className="sticky top-0 z-10" style={{ backgroundColor }}>
          <div className="max-w-[430px] mx-auto">
            {header}
          </div>
        </div>
      )}

      {/* Scrollable content area */}
      <div className="flex-1 overflow-y-auto">
        <div className="max-w-[430px] mx-auto px-6">
          {children}
        </div>
      </div>

      {/* Sticky footer */}
      {footer && (
        <div className="sticky bottom-0 z-10" style={{ backgroundColor }}>
          <div className="max-w-[430px] mx-auto">
            {footer}
          </div>
        </div>
      )}
    </div>
  );
}
